<template>
  <div class="details">
    <i
      class="el-icon-close"
      style="position: absolute;left: 3px; top: 5px; font-size: 25px; cursor: pointer;"
      @click="$emit('close')"
    />
    <div class="details_add">
      <div class="add_item">
        <span class="item_title">投放组</span>
        <span class="item_non">{{ drawerItem.release_group_name }}</span>
      </div>
      <div class="add_item">
        <span class="item_title">上级</span>
        <el-select
          v-model="addParameter.parent_leader_id"
          placeholder="请选择"
          filterable
          :disabled="isP"
          @clear="addParameter.parent_leader_id = null"
        >
          <el-option
            v-for="item in tableData.group_user"
            :key="item.user_id"
            :label="item.nickname"
            :value="item.user_id"
          />
        </el-select>
      </div>
      <div class="add_item">
        <span class="item_title">投手</span>
        <el-select
          v-model="addParameter.user_id"
          placeholder="请选择"
          filterable
          :disabled="isP"
          @clear="addParameter.user_id = null"
        >
          <el-option
            v-for="item in tableData.user"
            :key="item.id"
            :label="item.nickname"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="add_item">
        <span class="item_title">飞书成员</span>
        <el-autocomplete
          v-model="app_id"
          :disabled="isP"
          :fetch-suggestions="querySearchAsync"
          placeholder="请选择飞书成员"
          @clear="(app_id = null)"
          @select="handleSelect"
        />
      </div>
      <el-button
        type="primary"
        style="margin-left: 310px"
        @click="addPitcher"
      >添加</el-button>
    </div>
    <div class="details_contentArea">
      <el-table
        v-loading="loading"
        :data="list"
        max-height="500"
        row-key="id"
        border
        style="width: 80%; margin:0 auto;"
        :tree-props="{children: 'child'}"
      >
        <el-table-column
          prop="user_id"
          label="用户id"
        />
        <el-table-column
          prop="user_name"
          label="用户名"
        />
        <el-table-column
          prop="feishu_account"
          label="飞书id"
        />
        <el-table-column
          prop="feishu_name"
          label="飞书人员"
        />
        <el-table-column label="操作">
          <template scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="deletePitcher(scope.row)"
            >删除</el-button>
            <el-button
              v-if="isChildRow(scope.row)"
              type="success"
              size="mini"
              @click="extraAction(scope.row)"
            >
              更换组
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <pagination-right
        :total="tableData.count"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      /> -->
    </div>
    <el-dialog
      title="更换组"
      :visible.sync="dialog"
      width="30%"
      append-to-body
    >
      投放组：
      <el-select v-model="upd_group.group_id" filterable placeholder="请选择" :filter-method="getGroupList" @change="groupChange">
        <el-option
          v-for="item in group_data"
          :key="item.id"
          :label="item.release_group_name"
          :value="item.id"
        />
      </el-select>
      <br>
      <br>
      <br>
      投手：
      <el-select v-model="upd_group.parent_leader_id" filterable placeholder="请选择" :filter-method="getGroupUserList">
        <el-option
          v-for="item in group_user_data"
          :key="item.user_id"
          :label="item.nickname"
          :value="item.user_id"
        />
      </el-select>
      <div style="margin-top: 50px">
        <el-button type="success" @click="quickCommit">确定</el-button>
        <el-button type="info" @click="dialog = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getListOfPitchersInTheLaunchGroup,
  addOfPitchersInTheLaunchGroup,
  deleteOfPitchersInTheLaunchGroup,
  feishuuserlist,
  getReleaseGroupList, replaceReleaseGroup
} from '@/api/releaseGroup.js'
// import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    // PaginationRight
  },
  props: {
    drawerItem: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      defaultProps: {
        children: 'child',
        label: 'user_name'
      },
      tableData: {},
      isP: true,
      app_id: null,
      app_ids: null,
      pageinfo: {
        page: 1,
        pageSize: 10
      },
      parameter: {
        page: 1,
        pageSize: 10,
        group_id: this.drawerItem.id
      },
      addParameter: {
        group_id: this.drawerItem.id,
        user_id: null
      },
      loading: false,
      list: [],
      dialog: false,
      group_data: [],
      group_user_value: null,
      group_user_data: null,
      upd_group: {
        id: null,
        group_id: null,
        parent_leader_id: null
      }
    }
  },
  created() {
    this.getDataList()
  },
  mounted() {
    setTimeout(() => {
      this.isP = false
    })
  },
  methods: {
    handleNodeClick(v) {
      console.log('v', v)
    },
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await getListOfPitchersInTheLaunchGroup(this.parameter)
      console.log('data:', data)
      this.tableData = data.data
      this.list = [data.data.list]
      this.loading = false
    },
    fetchPageSize(s) {
      this.parameter.pageSize = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },

    // 添加投手
    async addPitcher() {
      let text = null
      this.addParameter.user_id || (text = '请选择投手')
      if (this.app_id === null) {
        this.$message({
          message: '请选择上级',
          type: 'warning'
        })
        return
      }
      if (this.app_ids === null) {
        this.$message({
          message: '请选择正确的飞书成员',
          type: 'warning'
        })
        return
      }
      // this.addParameter.parent_leader_id = this.addParameter.user_id
      text || (await addOfPitchersInTheLaunchGroup({ ...this.addParameter, feishu_name: this.app_id, feishu_account: this.app_ids }))
      text || this.getDataList()
      text || ((this.addParameter.user_id = null), (this.app_id = null), (this.app_ids = null))
      this.$message({
        message: text || '添加成功',
        type: text ? 'warning' : 'success'
      })
    },

    // 删除投手
    async deletePitcher(row) {
      await deleteOfPitchersInTheLaunchGroup({ id: row.id })
      this.getDataList()
      this.$message({
        message: '删除成功',
        type: 'success'
      })
    },
    async querySearchAsync(queryString, cb) {
      if (queryString === '') {
        this.app_id = null
        this.app_ids = null
      }
      const data = await feishuuserlist({ ...this.pageinfo, user_name: this.app_id })
      const newArr = data.data.map(item => {
        return { ...item, value: item.name, address: item.openId }
      })
      cb(newArr)
    },
    querySearch(queryString, cb) {
      // let results = []
      // if (queryString) {
      //   const findout = this.tableData.user.filter((x) => firstCharFilter(x, this.querySearch))
      //   results = findout.map(x => ({ ...x, value: '[lavel: ' + x.label + ': name: ' + x.name + ']' }))
      // } else {
      //   results = this.tableData.user.map(x => ({ ...x, value: x.label }))
      // }
    },
    handleSelect(val) {
      this.app_ids = val.openId
      console.log(val)
    },
    extraAction(val) {
      this.dialog = true
      this.getGroupList()
      this.upd_group.id = val.id
    },
    getGroupList(val) {
      getReleaseGroupList({ name: val }).then((res) => {
        this.group_data = res.data.list
      })
    },
    groupChange() {
      this.getGroupUserList()
    },
    getGroupUserList(val) {
      getListOfPitchersInTheLaunchGroup({ group_id: this.upd_group.group_id, name: val }).then((res) => {
        console.log(res)
        this.group_user_data = res.data.group_user
      })
    },
    quickCommit() {
      console.log(this.upd_group)
      replaceReleaseGroup(this.upd_group).then((res) => {
        console.log(res)
        if (res.code === 0) {
          this.$message.success('提交成功')
          this.dialog = false
          this.getDataList()
        }
      })
    },
    isChildRow(row) {
      // 遍历整个 list，检查 row 是否在某个父节点的 child 数组里
      const checkIfChild = (data) => {
        for (const item of data) {
          if (item.child && item.child.some(child => child.id === row.id)) {
            return true // 是子节点
          }
          if (item.child && item.child.length > 0) {
            if (checkIfChild(item.child)) return true
          }
        }
        return false
      }
      return checkIfChild(this.list)
    }
  }
}
</script>

<style scoped>
.details {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 100px;
}

.details_add {
  width: 80%;
  margin: 0 auto;
}

.add_item {
  margin-bottom: 15px;
}

.item_title {
  display: inline-block;
  width: 100px;
}

.details_contentArea {
  margin-top: 50px;
  max-height: 500px;
}
</style>
